/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {USER_UPDATE, USER_LOGOUT, UserActions} from 'store/action/user';

export interface IUserState {
  applicationId?: string;
}

const userReducer: Reducer<Readonly<IUserState>, UserActions> = (
  userState: IUserState = {},
  action: UserActions
) => {
  switch (action.type) {
    case USER_UPDATE: {
      return {
        ...userState,
        applicationId: action.applicationId
      };
    }

    case USER_LOGOUT: {
      return {
        ...userState,
        applicationId: ''
      };
    }

    default: return userState;
  }
};

export default userReducer;